import { useSelector } from 'react-redux';
import { RootState } from '../@types/RootState';
import { canAccessIpaDemandForecast } from '../utils/ipaAccess';

// O seletor devolve o booleano pronto: a celula do Gerenciador renderiza uma
// vez por linha e so re-renderiza quando o acesso muda, nao a cada update do usuario.
const selectCanAccessDemandForecast = (state: RootState): boolean => canAccessIpaDemandForecast(state.clienteDataReducer?.clienteData);

export const useCanAccessDemandForecast = (): boolean => useSelector(selectCanAccessDemandForecast);
